import { PageEvents } from "Component/Page/PageEvent";

export const pageDisappear = ( page: PageEvents ) => ({
    type: `${page}`,
});
